import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const DetailKerja = () => {
  let { Id } = useParams();

  const [detailData, setDetailData] = useState(null);

  useEffect(() => {
    if (Id !== undefined) {
      axios
        .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${Id}`)
        .then((res) => {
          // console.log(res);
          let data = res.data;
          setDetailData(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [Id]);

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(number);
  };

  // console.log(detailData);
  return (
    <React.Fragment>
      {/* component */}
      <section className="text-gray-700 body-font overflow-hidden">
        <div className="container px-5 py-24 mx-auto border-2 border-cyan-400 border-dashed">
          <div className="lg:w-4/5 mx-auto flex flex-wrap">
            <img
              alt="ecommerce"
              className="w-1/2 sm:mx-auto object-contain object-center rounded border border-gray-200"
              src={detailData?.company_image_url}
            />
            <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
              <h1 className="text-2xl font-semibold">Detail Lowongan</h1>
              <h2 className="text-sm title-font text-gray-500 tracking-widest">
                {detailData?.company_city}
              </h2>
              <h2 className="text-sm title-font text-gray-500 tracking-widest">
                {detailData?.company_name}
              </h2>
              <h1 className="text-gray-900 text-3xl title-font font-medium mb-1">
                {detailData?.title}
              </h1>

              <p className="leading-relaxed">{detailData?.job_description}</p>
              <hr />
              <h5 className="text-xl capitalize my-2">
                kualifikasi yang dibutuhkan: <br />
                {detailData?.job_qualification}
              </h5>
              <hr />
              <h5 className="text-xl capitalize my-2">
                Kontrak Kerja: {detailData?.job_tenure}
              </h5>
              <hr />
              <h5 className="text-xl capitalize my-2">
                Tipe Kerja: {detailData?.job_type}
              </h5>
              <hr />
              <h5 className="text-xl capitalize my-2">
                Gaji: {rupiah(detailData?.salary_min)} -{" "}
                {rupiah(detailData?.salary_max)}
              </h5>
              <div className="flex mt-8">
                <button className="flex ml-auto text-white bg-cyan-500 border-0 py-2 px-6 focus:outline-none hover:bg-cyan-600 rounded">
                  Lamar Sekarang
                </button>
              </div>
              <Link to="/job-vacancy">
                <div className="flex mt-8">
                  <button className="flex ml-auto text-white bg-red-500 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded">
                    Kembali ke Lowongan
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default DetailKerja;
